export const codelistLoadingState = {
	SUCCESS: 'SUCCESS',
	LOADING: 'LOADING',
};

export const codelists = {
	assignLevels: 'ASSIGN_LEVELS',
	bankCode: 'BANK_CODE',
	campaignChannels: 'CAMPAIGN_CHANNELS',
	campaignDataColumns: 'CAMPAIGN_DATA_COLUMNS',
	campaignStates: 'CAMPAIGN_STATES',
	communicationActivity: 'COMMUNICATION_ACTIVITY',
	communicationActivityResult: 'COMMUNICATION_ACTIVITY_RESULT',
	communicationChannel: 'COMMUNICATION_CHANNEL',
	contactSource: 'CONTACT_SOURCE',
	distributionChannel: 'DISTRIBUTION_CHANNEL',
	finishTypes: 'FINISH_TYPES',
	finishTypesAll: 'FINISH_TYPES_ALL',
	holidays: 'HOLIDAYS',
	idkAgencies: 'IDK_AGENCIES',
	idkRegions: 'IDK_REGIONS',
	kCProduct: 'KC_PRODUCT',
	kvitanceAccount: 'KVITANCE_ACCOUNT',
	parameters: 'PARAMETERS',
	payFreq: 'PAY_FREQ',
	policyStatuses: 'POLICY_STATUSES',
	policyPaymentStatuses: 'POLICY_PAYMENT_STATUSES',
	printTypes: 'PRINT_TYPES',
	productDomains: 'PRODUCT_DOMAINS',
	productGroupRel: 'PRODUCT_GROUP_REL',
	productGroup: 'PRODUCT_GROUP',
	productTypes: 'PRODUCT_TYPES',
	products: 'PRODUCTS',
	ppProducts: 'PP_PRODUCTS',
	ppRiskGroups: 'PP_RISKGROUPS',
	ppProductRiskGroups: 'PP_PRODUCT_RISKGROUPS',
	ppDocumentType: 'PP_DOCUMENT_TYPE',
	semaphoreContactTypes: 'SEMAPHORE_CONTACT_TYPE',
	semaphoreFeedback: 'SEMAPHORE_FEEDBACK',
	semaphorePrediction: 'SEMAPHORE_PREDICTION',
	semaphoreSegmentation: 'SEMAPHORE_SEGMENTATION',
	solutionState: 'SOLUTION_STATE',
	solutionStateVirtual: 'SOLUTION_STATES_COMBOBOX',
	statisticsEdkChannels: 'STATISTICS_EDK_CHANNELS',
	statisticsEdkRegions: 'STATISTICS_EDK_REGIONS',
	systems: 'SYSTEMS',
	taskStatus: 'TASK_STATUS',
	taskSubtypes: 'TASK_SUBTYPES',
	taskTypes: 'TASK_TYPES',
	tiaPackages: 'TIA_PACKAGES',
	workplace: 'WORKPLACE',
	zipCodeRage: 'ZIP_CODE_RAGE',
	emailDomains: 'EMAIL_DOMAINS',
	daImportConfig: 'DA_IMPORT_CONFIG',
	unlockChannels: 'UNLOCK_CHANNELS',
	backOfficeSegment: 'BACKOFFICE_SEGMENT',
	raProductGroups: 'RA_PRODUCT_GROUPS',
	raAnalysisTypes: 'RA_ANALYSIS_TYPES',
	raAnalysisStates: 'RA_ANALYSIS_STATES',
	notificationsSet: 'NOTIFICATIONS_SET',
	notificationsSetContacts: 'NOTIFICATIONS_SET_KCL',
	documentType: 'DOCUMENT_TYPE',
	documentState: 'DOCUMENT_STATE',
	documentCheckFinalStateAdmin: 'DOCUMENT_CHECK_FINAL_STATE_ADMIN',
	documentCheckFinalState: 'DOCUMENT_CHECK_FINAL_STATE',
};
